import { IAuthTokenError } from './authTokenTypes';

export function isTokenError(
  tokenOrError: unknown,
): tokenOrError is IAuthTokenError {
  if (!tokenOrError) {
    return false;
  }
  return (tokenOrError as IAuthTokenError).type !== undefined;
}
